module.exports = __webpack_public_path__ + "static/bard-66105db9e83122cdd1e5ea4b6cfba774.jpeg";